export const getPriceForCurrency = (priceObj, currencyCode) => {
  if (priceObj.unit_price.currency_code === currencyCode) {
    return priceObj.unit_price;
  }

  const override = priceObj?.unit_price_overrides?.find((o) =>
    o.country_codes.includes(
      currencyCode === "USD" ? "US" : currencyCode === "INR" ? "IN" : "GB",
    ),
  );

  return override?.unit_price || priceObj.unit_price;
};

export const CURRENCY_OPTIONS = [
  { label: "GBP (£)", value: "GBP" },
  { label: "USD ($)", value: "USD" },
  { label: "INR (₹)", value: "INR" },
];

export const CURRENCY_SYMBOL = {
  GBP: "£",
  USD: "$",
  INR: "₹",
};

export const getSubscriptionDetails = (currentPlan) => {
  return (
    currentPlan?.items?.reduce(
      (acc, item) => {
        const product = item?.product;
        const price = item?.price;

        if (product?.name === "Kelu Per Seat") {
          acc.perSeat = { ...product, price, quantity: item?.quantity };
        } else {
          acc.selectedPlan = { ...product, price };
        }

        return acc;
      },
      { perSeat: null, selectedPlan: null },
    ) || { perSeat: null, selectedPlan: null }
  );
};

export const checkIsOwner = ({ tenant_id, tenants }) => {
  return tenants?.[tenant_id]?.role === "OWNER";
};
